import styled from "styled-components";

interface ContainerProps {
  isHomeActive?: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    margin-bottom: ${({ isHomeActive }) => isHomeActive ? '-20%' : '10%'};
  }
`;
